import { render, staticRenderFns } from "./Sallary.vue?vue&type=template&id=b7dee0ea&"
import script from "./Sallary.vue?vue&type=script&lang=js&"
export * from "./Sallary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports